import { createFileRoute } from "@tanstack/react-router"
import { useCollectionContext } from "~/context/CollectionProvider"
import { useVariantContext } from "~/context/VariantProvider"
import { usePageTracking } from "~/hooks/usePageTracking"
import CollectionOverviewTab from "~/components/collections/tabs/CollectionOverviewTab"

export const Route = createFileRoute("/_auth/demand-planning/fashion/$collectionId/_layout/")({
  component: RouteComponent,
})

function RouteComponent() {
  usePageTracking("Collection Overview")
  const { collections, collectionGroups } = useCollectionContext()
  const { variants } = useVariantContext()

  const firstCollection = collections[0]
  const collectionGroup = firstCollection
    ? collectionGroups.find((g) => g.id === firstCollection.collectionGroupId)
    : undefined

  return (
    <CollectionOverviewTab
      collections={collections}
      collectionGroup={collectionGroup}
      variants={variants}
    />
  )
}
